import { useEffect } from "react";
import { useI18n } from "../i18n/i18n";
import { useSeo } from "../hooks/useSeo";

function Row({ label, value, isLink, href, testId }) {
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-4 gap-2 md:gap-6 py-3 border-b border-white/5"
      data-testid={testId}
    >
      <dt className="text-xs uppercase tracking-[0.18em] text-slate-400 md:col-span-1 self-center">
        {label}
      </dt>
      <dd className="md:col-span-3 text-slate-100 text-[15px]">
        {isLink ? (
          <a className="text-sky-400 hover:text-sky-300" href={href}>
            {value}
          </a>
        ) : (
          value
        )}
      </dd>
    </div>
  );
}

export default function Impressum() {
  const { t, lang } = useI18n();

  useSeo({
    title: "Impressum",
    description:
      lang === "de"
        ? "Impressum & Anbieterkennzeichnung von Cloudship (Samer Alshreibati, Freiberufler in Krefeld)."
        : "Legal notice (Impressum) for Cloudship (Samer Alshreibati, freelance Azure consultant based in Krefeld, Germany).",
    path: "/impressum",
    lang,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <main data-testid="impressum-page" className="pt-32 pb-24">
      <section className="max-w-3xl mx-auto px-6 md:px-8">
        <p className="cs-overline mb-4">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white leading-tight">
          {t("impressum.title")}
        </h1>
        <p className="text-slate-400 mt-4">{t("impressum.intro")}</p>

        <div className="cs-divider my-8" />

        <h2 className="font-display text-xl text-white mb-2">
          {t("impressum.provider_heading")}
        </h2>
        <dl className="mt-4">
          <Row label={t("impressum.name_label")} value={t("impressum.name_value")} testId="imp-name" />
          <Row label={t("impressum.role_label")} value={t("impressum.role_value")} testId="imp-role" />
          <Row label={t("impressum.address_label")} value={t("impressum.address_value")} testId="imp-address" />
          <Row
            label={t("impressum.phone_label")}
            value={t("impressum.phone_value")}
            isLink
            href="tel:+4915732521421"
            testId="imp-phone"
          />
          <Row
            label={t("impressum.email_label")}
            value={t("impressum.email_value")}
            isLink
            href={`mailto:${t("impressum.email_value")}`}
            testId="imp-email"
          />
          <Row
            label={t("impressum.web_label")}
            value={t("impressum.web_value")}
            isLink
            href="https://www.cloud-ship.de"
            testId="imp-web"
          />
          <Row
            label={t("impressum.vat_label")}
            value={t("impressum.vat_value")}
            testId="imp-vat"
          />
        </dl>

        <div className="cs-divider my-10" />

        <h2 className="font-display text-xl text-white mb-3">
          {t("impressum.responsible_heading")}
        </h2>
        <p className="text-slate-200 text-[15px]">{t("impressum.responsible_value")}</p>

        <div className="cs-divider my-10" />

        <h2 className="font-display text-xl text-white mb-3">
          {t("impressum.dispute_heading")}
        </h2>
        <p className="text-slate-300 leading-relaxed">{t("impressum.dispute_body")}</p>

        <p className="text-xs text-slate-500 mt-10">
          {t("impressum.source_label")}:{" "}
          <a
            href={t("impressum.source_value")}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sky-400 hover:text-sky-300"
          >
            {t("impressum.source_value")}
          </a>
        </p>
      </section>
    </main>
  );
}
